class ProductCardScroll extends HTMLElement {
  constructor() {
    super();
    this.loaded = false;
    this.arrowsInitialized = false;

    this.onUserInteract = this.onUserInteract.bind(this);
    this.onScrollUpdate = this.onScrollUpdate.bind(this);
    this.isRTL = false;

  }

  connectedCallback() {
    this.gallery = this.querySelector('.product-card-gallery-scroll');
    if (!this.gallery) return;

      this.startX = 0;
  this.hasMoved = false;

  this.gallery.addEventListener('touchstart', (e) => {
    this.startX = e.touches[0].clientX;
    this.hasMoved = false;
  }, { passive: true });

  this.gallery.addEventListener('touchmove', (e) => {
    const delta = Math.abs(e.touches[0].clientX - this.startX);
    if (delta > 8) this.hasMoved = true;  
  }, { passive: true });

  this.gallery.addEventListener('touchend', (e) => {
    if (!this.hasMoved) {
      const link = this.closest('a');
      if (link) link.click();
    }
  });

    const style = window.getComputedStyle(this.gallery);
    this.isRTL = style.direction === "rtl";

    try {
      this.media = JSON.parse(this.gallery.dataset.media || '[]');
    } catch (e) {
      console.error("Bad media JSON:", e);
      return;
    }

    this.gallery.addEventListener('wheel', this.onUserInteract, { passive: true });
    this.gallery.addEventListener('touchstart', this.onUserInteract, { passive: true });
    this.gallery.addEventListener('mousemove', this.onUserInteract);
    this.gallery.addEventListener('mousedown', this.onUserInteract);
    this.gallery.addEventListener('scroll', this.onScrollUpdate);
  }

  disconnectedCallback() {
    if (!this.gallery) return;

    this.gallery.removeEventListener('wheel', this.onUserInteract);
    this.gallery.removeEventListener('touchstart', this.onUserInteract);
    this.gallery.removeEventListener('mousemove', this.onUserInteract);
    this.gallery.removeEventListener('mousedown', this.onUserInteract);
    this.gallery.removeEventListener('scroll', this.onScrollUpdate);
  }

  onUserInteract() {
    if (!this.loaded) this.loadRemainingImages();

    if (!this.arrowsInitialized) {
      this.initArrows();
      this.onScrollUpdate(); 
    }
  }


  initArrows() {


    this.arrowsInitialized = true;

    this.leftArrow = document.createElement('button');
    this.rightArrow = document.createElement('button');

    this.leftArrow.className = 'pcg-arrow left';
    this.rightArrow.className = 'pcg-arrow right';

    this.leftArrow.innerHTML = `<svg version="1.1" id="fi_271220" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve">
              <g>
                <g>
                  <path d="M198.608,246.104L382.664,62.04c5.068-5.056,7.856-11.816,7.856-19.024c0-7.212-2.788-13.968-7.856-19.032l-16.128-16.12
                    C361.476,2.792,354.712,0,347.504,0s-13.964,2.792-19.028,7.864L109.328,227.008c-5.084,5.08-7.868,11.868-7.848,19.084
                    c-0.02,7.248,2.76,14.028,7.848,19.112l218.944,218.932c5.064,5.072,11.82,7.864,19.032,7.864c7.208,0,13.964-2.792,19.032-7.864
                    l16.124-16.12c10.492-10.492,10.492-27.572,0-38.06L198.608,246.104z"></path>
                </g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              </svg>`;
    this.rightArrow.innerHTML = `<svg version="1.1" id="fi_271228" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 492.004 492.004" style="enable-background:new 0 0 492.004 492.004;" xml:space="preserve">
            <g>
              <g>
                <path d="M382.678,226.804L163.73,7.86C158.666,2.792,151.906,0,144.698,0s-13.968,2.792-19.032,7.86l-16.124,16.12
                  c-10.492,10.504-10.492,27.576,0,38.064L293.398,245.9l-184.06,184.06c-5.064,5.068-7.86,11.824-7.86,19.028
                  c0,7.212,2.796,13.968,7.86,19.04l16.124,16.116c5.068,5.068,11.824,7.86,19.032,7.86s13.968-2.792,19.032-7.86L382.678,265
                  c5.076-5.084,7.864-11.872,7.848-19.088C390.542,238.668,387.754,231.884,382.678,226.804z"></path>
              </g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            </svg>`;

    this.appendChild(this.leftArrow);
    this.appendChild(this.rightArrow);

      this.leftArrow.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.gallery.scrollBy({ left: -150, behavior: 'smooth' });
      });

      this.rightArrow.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.gallery.scrollBy({ left: 150, behavior: 'smooth' });
      });
  }


onScrollUpdate() {
  if (!this.arrowsInitialized) return;

  const maxScroll = this.gallery.scrollWidth - this.gallery.clientWidth;
  let scrollLeft = this.gallery.scrollLeft;

  const tolerance = 1;

  if (this.isRTL) {
    const absScroll = Math.abs(scrollLeft);

    if (absScroll < maxScroll - tolerance) {
      this.leftArrow.classList.add('visible');
    } else {
      this.leftArrow.classList.remove('visible');
    }

    if (absScroll > tolerance) {
      this.rightArrow.classList.add('visible');
    } else {
      this.rightArrow.classList.remove('visible');
    }

  } else {
    // LTR רגיל
    if (scrollLeft < maxScroll - tolerance) {
      this.leftArrow.classList.add('visible');
    } else {
      this.leftArrow.classList.remove('visible');
    }

    if (scrollLeft > tolerance) {
      this.rightArrow.classList.add('visible');
    } else {
      this.rightArrow.classList.remove('visible');
    }
  }
}



  loadRemainingImages() {
    this.loaded = true;

    const rest = (this.media || []).slice(1);

    rest.forEach(m => {
      let src = m?.preview_image?.src || m?.src;
      if (!src) return;

      if (src.startsWith('//')) src = 'https:' + src;
      if (src.endsWith('.jpg')) src = src.replace('.jpg', '_600x.jpg');

      const img = document.createElement('img');
      img.className = 'pcg-img';
      img.loading = "lazy";
      img.src = src;

      this.gallery.appendChild(img);
    });
  }
}

customElements.define("product-card-scroll", ProductCardScroll);
